// extracted by mini-css-extract-plugin
export var cdsAssistiveText = "GifPlayer-module--cds--assistive-text--9f628";
export var cdsHideFeedback = "GifPlayer-module--cds--hide-feedback--cf5db";
export var cdsShowFeedback = "GifPlayer-module--cds--show-feedback--46a91";
export var cdsSkeleton = "GifPlayer-module--cds--skeleton--6a310";
export var cdsVisuallyHidden = "GifPlayer-module--cds--visually-hidden--58bfd";
export var container = "GifPlayer-module--container--cbb6b";
export var controls = "GifPlayer-module--controls--ac003";
export var dark = "GifPlayer-module--dark--6f61f";
export var gifDisplayed = "GifPlayer-module--gif-displayed--8cc4e";
export var gifHidden = "GifPlayer-module--gif-hidden--4177d";
export var gifInDialog = "GifPlayer-module--gif-in-dialog--15780";
export var imgDisplayed = "GifPlayer-module--img-displayed--bd812";
export var imgHidden = "GifPlayer-module--img-hidden--3f785";